import img16a from '../../../assets/gallery/16d/16d-01-HOME_vista.jpg';
import img16b from '../../../assets/gallery/16d/16d-02_Noiromence-1-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-panel.jpg';
import img16c from '../../../assets/gallery/16d/16d-03_Noiromence-2-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img16a,
    description: "2016",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "400 x 300 cm",
    pictureSrc: img16b,
    description: "2016",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "400 x 300 cm",
    pictureSrc: img16c,
    description: "2016",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/16d/data16d.js